import type { FullGroupSubmissionType, FullIndividualSubmissionType } from "./types";

import type { GroupSubmissionType, IndividualSubmissionType } from "components/server-types";

export function isIndividualSubmission(
  submission: IndividualSubmissionType | GroupSubmissionType,
): submission is IndividualSubmissionType;
export function isIndividualSubmission(
  submission: FullIndividualSubmissionType | FullGroupSubmissionType,
): submission is FullIndividualSubmissionType {
  return submission.section_user_id !== null;
}

export function isGroupSubmission(
  submission: IndividualSubmissionType | GroupSubmissionType,
): submission is GroupSubmissionType;
export function isGroupSubmission(
  submission: FullIndividualSubmissionType | FullGroupSubmissionType,
): submission is FullGroupSubmissionType {
  return submission.page_group_id !== null;
}
